module.exports = __webpack_public_path__ + "static/img/image_colour.623f0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/image_colour.jpg
// module id = Kg5V
// module chunks = 2